import { Component, h, Host, Prop } from '@stencil/core';
import { ListProduct, ProductImage } from '~model/product';
import { translate } from '~service/translation-service';

@Component({
  tag: 'uvex-product',
})
export class Product {
  @Prop() product: ListProduct;

  renderVariants() {
    const { variants, mainImage, link } = this.product;
    const numberOfVariants = Object.keys(variants).length > 2 ? Object.keys(variants).length - 2 : null;

    if (Object.keys(variants).length === 0) {
      return;
    }

    return (
      <div class="variants">
        <a href={link} class="active">
          {this.renderImage(mainImage, 60)}
        </a>
        {Object.keys(variants).map((key, index) => {
          if (index > 1) {
            return;
          }
          const { mainImage, link } = variants[key];
          return <a href={link}>{this.renderImage(mainImage, 60)}</a>;
        })}
        {numberOfVariants ? <span class="number-of-extra-variants">+{numberOfVariants}</span> : ''}
      </div>
    );
  }

  renderCo2Wolke() {
    if (!this.product.sustainability?.balance) {
      return;
    }

    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.757 52.575" class="co2-wolke co2-wolke-list">
        <defs>
          <clipPath id="a">
            <path fill="none" d="M0 0h52.575v52.575H0z" data-name="Rechteck 1509" />
          </clipPath>
          <clipPath id="b">
            <path fill="none" d="M-.001 21.096c0 11.651 9 21.1 20.092 21.1s20.092-9.445 20.092-21.1-9-21.1-20.092-21.1S-.001 9.445-.001 21.096" data-name="Pfad 27" />
          </clipPath>
          <clipPath id="c">
            <path
              fill="none"
              d="M21.129 20.125a18.743 18.743 0 0 0 6.131-1.559 19.621 19.621 0 0 0 6.069-4.24 23.241 23.241 0 0 0-4.947-2.84 25.039 25.039 0 0 1-7.254 8.639M5.911 14.314a19.606 19.606 0 0 0 6.08 4.252 18.739 18.739 0 0 0 6.138 1.56 25.033 25.033 0 0 1-7.26-8.651 23.161 23.161 0 0 0-4.958 2.84m14.143 5.5a24.079 24.079 0 0 0 7.52-8.647 22.546 22.546 0 0 0-7.52-1.437Zm-8.376-8.658a24.083 24.083 0 0 0 7.52 8.654V9.728a22.63 22.63 0 0 0-7.52 1.427M-.001 0a21.267 21.267 0 0 0 3.353 11.1 20.575 20.575 0 0 0 1.954 2.57 24.034 24.034 0 0 1 5.171-2.993A26.167 26.167 0 0 1 8.028.004Zm8.885 0a25.226 25.226 0 0 0 2.4 10.351 23.455 23.455 0 0 1 7.918-1.521V0Zm11.171 0v8.83a23.366 23.366 0 0 1 7.92 1.531 25.23 25.23 0 0 0 2.4-10.362Zm11.177 0a26.161 26.161 0 0 1-2.454 10.684 24.121 24.121 0 0 1 5.16 2.993A21.116 21.116 0 0 0 39.256 0Z"
              data-name="Pfad 29"
            />
          </clipPath>
          <clipPath id="e">
            <path
              fill="none"
              d="M39.711.001a21.116 21.116 0 0 1-5.318 13.677q-.215.24-.435.472l-.171.178a19.606 19.606 0 0 1-6.069 4.24 18.743 18.743 0 0 1-6.131 1.559q-.745.06-1.5.059c-.506 0-1-.019-1.5-.059a18.742 18.742 0 0 1-6.138-1.56 19.626 19.626 0 0 1-6.08-4.252q-.31-.318-.606-.649a20.489 20.489 0 0 1-1.954-2.57A21.264 21.264 0 0 1 .456-.004H.001v.147c0 .135.009.271.014.406a.208.208 0 0 0 0 .023v.059a.131.131 0 0 0 0 .019v.108C.542 10.47 7.326 18.422 16.2 20.242h7.747a19.118 19.118 0 0 0 2.464-.665l.026-.009h.007l.02-.007h.009l.019-.007h.01l.019-.006h.01l.019-.006h.01l.026-.009.016-.006h.011l.018-.006h.01l.019-.006h.007l.019-.007h.005l.021-.008A20.571 20.571 0 0 0 38.443 8.13c0-.008.007-.016.01-.024 0-.007.006-.015.01-.023l.01-.023a3.42 3.42 0 0 0 .041-.1l.009-.02v-.007l.008-.019a.019.019 0 0 1 0-.006l.008-.02v-.007l.008-.02v-.006c.009-.022.019-.045.027-.068v-.005l.008-.019v-.009l.007-.018a.055.055 0 0 1 0-.011.134.134 0 0 1 .007-.017.061.061 0 0 0 0-.011l.006-.016.005-.012.006-.015c0-.005 0-.011.006-.015l.007-.019.008-.019.005-.013.006-.016.005-.012a.076.076 0 0 1 .006-.015l.005-.013.006-.016v-.011l.006-.017v-.011a.179.179 0 0 0 .007-.019v-.009l.011-.027a.033.033 0 0 1 0-.008l.008-.02a.054.054 0 0 1 0-.011l.007-.019a.039.039 0 0 0 0-.011.143.143 0 0 1 .007-.018.039.039 0 0 1 0-.011l.007-.019v-.01l.008-.02v-.008l.011-.027.011-.03.01-.026a.019.019 0 0 1 0-.006l.008-.022a.024.024 0 0 1 0-.007l.008-.022a.035.035 0 0 1 0-.007.246.246 0 0 1 .009-.023.012.012 0 0 1 0-.005c0-.009.007-.019.01-.027l.021-.059.01-.026a.013.013 0 0 1 0-.005l.009-.024a.013.013 0 0 1 0-.005l.009-.025c0-.009.006-.018.01-.027l.042-.12c0-.01.006-.019.01-.028 0-.01.007-.019.01-.029l.042-.122c0-.011.006-.02.01-.03l.01-.03a21.7 21.7 0 0 0 .844-3.475l.005-.032.025-.163v-.09c0-.032.009-.064.014-.1v-.071a.024.024 0 0 1 0-.008.22.22 0 0 1 0-.024.027.027 0 0 1 0-.008v-.025a.02.02 0 0 1 0-.007v-.027c0-.022.005-.042.009-.064v-.027a.029.029 0 0 1 0-.009v-.022a.044.044 0 0 1 0-.011v-.02a.044.044 0 0 1 0-.011V2.32a.037.037 0 0 1 0-.01v-.023a.022.022 0 0 1 0-.008v-.031a.036.036 0 0 1 0-.01.173.173 0 0 1 0-.021.052.052 0 0 1 0-.012v-.019a.087.087 0 0 1 0-.014.109.109 0 0 1 0-.017.078.078 0 0 1 0-.014.1.1 0 0 1 0-.016.1.1 0 0 1 0-.015.106.106 0 0 1 0-.017.077.077 0 0 1 0-.014.108.108 0 0 1 0-.017v-.029a.077.077 0 0 1 0-.014.12.12 0 0 1 0-.018.067.067 0 0 1 0-.013v-.019a.051.051 0 0 1 0-.012.118.118 0 0 1 0-.018.069.069 0 0 1 0-.013v-.019a.058.058 0 0 1 0-.012.131.131 0 0 1 0-.018.043.043 0 0 1 0-.011l.008-.077a.214.214 0 0 1 0-.025v-.006a.221.221 0 0 1 0-.024v-.006a.218.218 0 0 1 0-.025.253.253 0 0 1 0-.026l.013-.143v-.029c.042-.492.07-.988.079-1.489h-.45Z"
              data-name="Pfad 31"
            />
          </clipPath>
          <linearGradient id="d" x1="-.159" x2="-.157" y1="1.27" y2="1.27" gradientUnits="objectBoundingBox">
            <stop offset="0" stop-color="#8098cb" />
            <stop offset="1" stop-color="#8098cb" />
          </linearGradient>
          <linearGradient id="f" x1="-.144" x2="-.142" y1="1.262" y2="1.262" gradientUnits="objectBoundingBox">
            <stop offset="0" stop-color="#8098cb" />
            <stop offset=".14" stop-color="#889fce" />
            <stop offset=".37" stop-color="#a1b2d8" />
            <stop offset=".66" stop-color="#c8d2e8" />
            <stop offset="1" stop-color="#fefefe" />
            <stop offset="1" stop-color="#fff" />
          </linearGradient>
        </defs>
        <g data-name="Gruppe 307">
          <g clip-path="url(#a)" data-name="Gruppe 264">
            <path fill="#8098cb" d="M3.93 28.516c0-11.651 9-21.1 20.092-21.1s20.092 9.445 20.092 21.1-9 21.1-20.092 21.1S3.93 40.167 3.93 28.516" data-name="Pfad 25" />
          </g>
          <g clip-path="url(#b)" data-name="Gruppe 265" transform="translate(3.931 7.42)">
            <path
              fill="#b3c2e0"
              d="M29.248 9.957a26.21 26.21 0 0 1 2.446 10.69h8.487v.9h-8.487a26.16 26.16 0 0 1-2.455 10.687 24.512 24.512 0 0 1 4.825 2.744c1.075 1.08-.377.727-.409.8.849.736-3.033-1.992-4.809-2.738a22.921 22.921 0 0 1-8.152 9.155h-1.032a23.334 23.334 0 0 1-8.329-9.167 23.589 23.589 0 0 0-4.6 2.577c-2.6 1.833.749-4.966-.762-.538a23.562 23.562 0 0 1 4.968-2.841A26.158 26.158 0 0 1 8.49 21.552H-.002v-.9h8.493A26.212 26.212 0 0 1 10.932 9.97a24.44 24.44 0 0 1-5.1-2.946c-.485.292.422-.886.681-.593a22.724 22.724 0 0 0 4.816 2.737 24.789 24.789 0 0 1 8.533-9.532l.216.367.254-.367a24.781 24.781 0 0 1 8.527 9.521c4.704-1.978 5.234-1.255.389.8Zm-.8.323a23.363 23.363 0 0 1-7.928 1.534v8.833h10.319a25.27 25.27 0 0 0-2.393-10.367m-8.783 1.534a23.461 23.461 0 0 1-7.927-1.524 25.28 25.28 0 0 0-2.388 10.356h10.314v-8.832m-7.53-2.328a22.611 22.611 0 0 0 7.529 1.43V.834a23.95 23.95 0 0 0-7.529 8.652m8.385 1.43a22.557 22.557 0 0 0 7.53-1.441 23.941 23.941 0 0 0-7.53-8.646v10.086m0 30.446a24.09 24.09 0 0 0 7.521-8.647 22.547 22.547 0 0 0-7.521-1.437v10.084m7.92-9.452a25.22 25.22 0 0 0 2.4-10.363H20.518v8.832a23.367 23.367 0 0 1 7.92 1.531M9.348 21.545a25.231 25.231 0 0 0 2.4 10.353 23.456 23.456 0 0 1 7.918-1.521v-8.832H9.348m2.794 11.157a24.075 24.075 0 0 0 7.52 8.654v-10.08a22.629 22.629 0 0 0-7.52 1.427"
              data-name="Pfad 26"
            />
          </g>
          <g data-name="Gruppe 306">
            <path
              fill="#fff"
              d="M3.93 28.515h.459a21.117 21.117 0 0 1 5.758-14.6 19.635 19.635 0 0 1 6.24-4.418 18.819 18.819 0 0 1 15.269 0 19.959 19.959 0 0 1 8.64 7.472 21.452 21.452 0 0 1-2.4 26.148 19.635 19.635 0 0 1-6.24 4.418 18.82 18.82 0 0 1-15.269 0 19.96 19.96 0 0 1-8.64-7.472 21.283 21.283 0 0 1-3.358-11.547h-.918a22.029 22.029 0 0 0 6.011 15.233 20.571 20.571 0 0 0 6.532 4.624 19.676 19.676 0 0 0 8.007 1.7 20.023 20.023 0 0 0 14.539-6.321 22.308 22.308 0 0 0 0-30.467 20.57 20.57 0 0 0-6.532-4.624 19.733 19.733 0 0 0-16.014 0 20.874 20.874 0 0 0-9.04 7.815 22.205 22.205 0 0 0-3.5 12.043h.459Z"
              data-name="Pfad 28"
            />
          </g>
          <g clip-path="url(#c)" data-name="Gruppe 267" transform="translate(4.394 28.968)">
            <path fill="url(#d)" d="M0 0h39.255v20.126H0z" data-name="Rechteck 1511" transform="translate(-.001 -.001)" />
          </g>
          <g clip-path="url(#e)" data-name="Gruppe 269" transform="translate(3.937 28.966)">
            <path fill="url(#f)" d="M0 0h40.17v20.253H0z" data-name="Rechteck 1513" transform="translate(.001 .001)" />
          </g>
          <g clip-path="url(#a)" data-name="Gruppe 270">
            <ellipse cx="20.092" cy="21.096" fill="none" stroke="#fff" stroke-miterlimit="10" data-name="Ellipse 37" rx="20.092" ry="21.096" transform="translate(3.929 7.42)" />
            <path
              fill="#1b398f"
              d="M19.372 29.463a7.369 7.369 0 0 1-7.46-7.257 7.243 7.243 0 0 1 5.379-6.964 5.7 5.7 0 0 1-.116-1.129 6.07 6.07 0 0 1 6.145-5.979 6.251 6.251 0 0 1 3.554 1.11 9.63 9.63 0 0 1 8.729-5.369 9.534 9.534 0 0 1 9.654 9.386 8.728 8.728 0 0 1-.121 1.41 8 8 0 0 1 3.629 6.682 8.235 8.235 0 0 1-8.338 8.109H19.372Z"
              data-name="Pfad 32"
            />
            <path
              fill="none"
              stroke="#fff"
              stroke-miterlimit="10"
              stroke-width="2"
              d="M19.372 29.463a7.369 7.369 0 0 1-7.46-7.257 7.243 7.243 0 0 1 5.379-6.964 5.7 5.7 0 0 1-.116-1.129 6.07 6.07 0 0 1 6.145-5.979 6.251 6.251 0 0 1 3.554 1.11 9.63 9.63 0 0 1 8.729-5.369 9.534 9.534 0 0 1 9.654 9.386 8.728 8.728 0 0 1-.121 1.41 8 8 0 0 1 3.629 6.682 8.235 8.235 0 0 1-8.338 8.109H19.372Z"
              data-name="Pfad 33"
            />
            <path
              fill="#fff"
              d="M38.779 24.14h4.763v-1.251H40.85c.379-.392 1.187-.708 1.769-1.175a1.892 1.892 0 0 0 .91-1.63c0-.986-.822-1.819-2.249-1.819a2.156 2.156 0 0 0-2.426 2.2h1.517a.87.87 0 0 1 .872-.986.654.654 0 0 1 .72.707c0 .682-.834.922-1.845 1.642a2.724 2.724 0 0 0-1.339 2.312m-5.382-2.931c-1.63 0-2.464-1.352-2.464-3.121s.834-3.159 2.464-3.159 2.426 1.377 2.426 3.159-.808 3.121-2.426 3.121m-.012 1.769c2.843 0 4.637-2.085 4.637-4.89s-1.794-4.9-4.637-4.9a4.553 4.553 0 0 0-4.65 4.9c0 2.817 1.794 4.89 4.65 4.89m-9.5-.012a4.028 4.028 0 0 0 2.981-1.062 3.812 3.812 0 0 0 1.138-2.438h-2.161a1.855 1.855 0 0 1-1.958 1.718c-1.478 0-2.413-1.3-2.413-3.1s.8-3.108 2.4-3.108a1.8 1.8 0 0 1 1.9 1.542h2.148a3.622 3.622 0 0 0-1.453-2.6 4.3 4.3 0 0 0-2.577-.732c-2.805 0-4.611 2.1-4.611 4.9a4.565 4.565 0 0 0 4.611 4.877"
              data-name="Pfad 34"
            />
          </g>
        </g>
      </svg>
    );
  }

  render() {
    if (this.product === null) {
      return;
    }
    const { variants, mainImage, price, link } = this.product;

    return (
      <Host class="product">
        <div class="product-inner">
          {this.renderCo2Wolke()}
          {this.product.tags.newArticle ? <span class="tag">{translate('sw.product.badge.new')}</span> : ''}
          <div class="picture-wrap">{this.renderImage(mainImage, mainImage?.width)}</div>

          {this.renderVariants()}

          <div class="title">
            <span>{this.product.name}</span>
          </div>

          <div
            class={{
              'spacer': true,
              'spacer-variants': Object.keys(variants).length > 0 || price !== null,
            }}
          />

          <div class="number-of-variants">{Object.keys(variants).length > 0 ? Object.keys(variants).length + 1 + ' ' + translate('sw.product.numberOfColorVariants') : ''}</div>

          {price !== null ? (
            <div class="prices">
              <div class="price" innerHTML={(price?.priceDifferenceExist ? translate('sw.product.priceFrom') + ' ' : '') + price?.gross?.formated} />
              <div class="uvp">({translate('sw.article.properties.withTax')})</div>
            </div>
          ) : (
            ''
          )}
          <a href={link} class="link-full" title={this.product.name} />
        </div>
      </Host>
    );
  }

  private renderImage(image: ProductImage, width: number) {
    if (image === null) {
      return null;
    }

    return (
      <picture class="ratio-picture" style={{ '--width': `${width}px`, '--aspect-ratio': `${image.ratio}` }}>
        <source media="(min-width: 1px)" srcSet={image.src} />
        <img width={image.width} height={image.height} loading="lazy" decoding="async" class="img-fluid" src={image.src} alt={this.product.name} title={this.product.name} />
      </picture>
    );
  }
}
